import type { TFunction } from 'i18next'
import { z } from 'zod'

import { EMPLOYMENT_STATUS, OCCUPATION } from '@/constants/user-profile'
import { ADDRESS_DEFAULTS, addressSchema, refineAddress } from './address'
import {
  OCCUPATION_DEFAULTS,
  occupationSchema,
  refineOccupation,
} from './occupation'

export { formatPostalCode } from './address'

const formSchema = addressSchema.merge(occupationSchema).extend({
  existingOccupation: z.string().trim(),
  isEditingOccupation: z.boolean(),
})

export type FormValues = z.infer<typeof formSchema>

export const DEFAULT_VALUES: FormValues = {
  ...ADDRESS_DEFAULTS,
  ...OCCUPATION_DEFAULTS,
  existingOccupation: '',
  isEditingOccupation: false,
}

export const formatOccupationDisplay = ({
  employmentStatus,
  occupation,
  occupationDetails,
}: {
  employmentStatus: string
  occupation: string
  occupationDetails: string
}): string => {
  if (employmentStatus === '') return ''

  if (
    employmentStatus !== EMPLOYMENT_STATUS.EMPLOYED &&
    employmentStatus !== EMPLOYMENT_STATUS.SELF_EMPLOYED
  ) {
    return employmentStatus
  }

  const title = occupation === OCCUPATION.OTHER ? occupationDetails : occupation
  if (title.trim() === '') return employmentStatus

  return employmentStatus === EMPLOYMENT_STATUS.SELF_EMPLOYED
    ? `${title} (${EMPLOYMENT_STATUS.SELF_EMPLOYED})`
    : title
}

export const buildSchema = (t: TFunction) =>
  formSchema.superRefine((values, ctx) => {
    refineAddress(values, ctx, t)

    const editingOrNoExisting =
      values.isEditingOccupation || values.existingOccupation.length === 0
    if (editingOrNoExisting) refineOccupation(values, ctx, t)
  })
